import { render, staticRenderFns } from "./Regulators.vue?vue&type=template&id=3ff41d34&"
import script from "./Regulators.vue?vue&type=script&lang=js&"
export * from "./Regulators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports